import React from 'react';
import McqOptions from './mcqFeedback.options';
import ListAnimation from '../../../utils/animations/list';

const McqIncorrect = () => (
	<ListAnimation className="no-mouse-events">
		<ul>
			<McqOptions />
		</ul>
		<input type="hidden" name="choosen-answer" className="choosen-answer" />
	</ListAnimation>
);

export default McqIncorrect;
